module.exports = __webpack_public_path__ + "assets/ad72d5d4f30e8740d5e7aa4ba3348aa4.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-500-normal.woff2
// module id = 2620
// module chunks = 121